<template>
  <div class="product-nav-row">
    <div class="product-nav-row__arenas">
      <ArenaStatusIndicator class="product-nav-arenas" size="xs" />
    </div>
    <div v-if="!isPopupOpen" class="product-nav-row__menu">
      <BurgerMenu embedded />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ArenaStatusIndicator from '@/components/bet-panel/arena-status-indicator.vue';
import BurgerMenu from '@/components/burger-menu.vue';

export default {
  components: {
    ArenaStatusIndicator,
    BurgerMenu,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      isPopupOpen: 'menu/isPopupOpen',
    }),
  },
};
</script>

<style lang="scss" scoped>
.product-nav-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 6px;
  width: 100%;
  height: 38px;
  min-height: 38px;
}

.product-nav-row__arenas {
  min-width: 0;
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.product-nav-arenas {
  width: 100%;
}

.product-nav-row__menu {
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  box-sizing: border-box;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: $ga-navy-750;
  border: 1px solid rgba(255, 255, 255, 0.22);

  ::v-deep .menu__burger {
    width: 28px;
    height: 28px;
  }
}

// Layout-only tweaks for the footer row. Colors/borders deliberately come from
// arena-status-indicator so the chips keep the original cockfight styling.
::v-deep .product-nav-arenas.arena-indicator.mobile {
  .arena-indicator-button-wrapper {
    margin: 0 6px 0 0;
  }

  // v2.1 arena tabs: 28px pills, 16px flag, 12px bold code.
  .arena-indicator-button {
    height: 28px;
    box-sizing: border-box;
    padding: 0 11px 0 5px;
    border-width: 1.5px;
    font-size: 12px;
    font-weight: 700;

    .flag-pill,
    .flag-ring {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
